import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

function Layout({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="layout">
      {isSidebarOpen && <Sidebar />}
      <div className="main">
        <Header onToggleSidebar={toggleSidebar} />
        <main className="content">{children}</main>
      </div>
    </div>
  );
}

export default Layout;
